import React from 'react';
import { Link } from 'react-router-dom';
import "./HomeStyle.css";

const Breadcrumbs = ({activeItemId}) => {
  const breadcrumbs = [
    { text: 'All Apps', link: '/' },
    { text: 'My First App', link: '/firstApp' },
    { text: 'Overview', link: '/products/Overview' },
  ];

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {breadcrumbs.map((breadcrumb, index) => (
          <li key={index} className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? 'active' : ''}`}>
            {index < breadcrumbs.length - 1 ? (
              <Link to={breadcrumb.link}>{breadcrumb.text}</Link>
            ) : (
              
              <span>
              {activeItemId}

              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
